import { Action } from '@ngrx/store';

export enum NotificationActionTypes {
  // GET_PERMISSION = '[Notification] Get Permission',
  // GET_PERMISSION_SUCCESS = '[Notification] Get Permission Success',
  // GET_PERMISSION_FAILURE = '[Notification] Get Permission Failure',

  SEND_TEAM_NOTIFICATION = '[Notification] Send Team Notification',
  SEND_TEAM_NOTIFICATION_SUCCESS = '[Notification] Send Team Notification Success',
  SEND_TEAM_NOTIFICATION_FAILURE = '[Notification] Send Team Notification Failure',
}

// export class GetPermission implements Action {
//   readonly type = NotificationActionTypes.GET_PERMISSION;
//   constructor(public payload: any) {}
// }
// export class GetPermissionSuccess implements Action {
//   readonly type = NotificationActionTypes.GET_PERMISSION_SUCCESS;
//   constructor(public payload: any) {}
// }
// export class GetPermissionFailure implements Action {
//   readonly type = NotificationActionTypes.GET_PERMISSION_FAILURE;
//   constructor(public payload: any) {}
// }

export class SendTeamNotification implements Action {
  readonly type = NotificationActionTypes.SEND_TEAM_NOTIFICATION;
  constructor(public payload: any) {}
}
export class SendTeamNotificationSuccess implements Action {
  readonly type = NotificationActionTypes.SEND_TEAM_NOTIFICATION_SUCCESS;
  constructor(public payload: any) {}
}
export class SendTeamNotificationFailure implements Action {
  readonly type = NotificationActionTypes.SEND_TEAM_NOTIFICATION_FAILURE;
  constructor(public payload: any) {}
}

export type All =
  // | GetPermission
  // | GetPermissionSuccess
  // | GetPermissionFailure
  | SendTeamNotification
  | SendTeamNotificationSuccess
  | SendTeamNotificationFailure;



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/store/actions/notification.actions.ts